/*  eslint-disable no-param-reassign */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import TranslationProvider from '../../../../../ui-kitchen/src/providers/TranslationProvider';
import { sanitizeString } from '../../../../../ui-kitchen/src/utils/sanitizeString';
import OPENAI_WIDGET, { BELI_WIDGET } from '../../constants/srcTypes';

const SummaryLegalText = ({ legalText, sourceId }) => {
  const sanitizedLegalText = sanitizeString(legalText);
  const legalTextRef = useRef(null);
  const showOaiGlobalDiningAccessCopy = [OPENAI_WIDGET, BELI_WIDGET].includes(sourceId);

  const openLegalLink = (link) => {
    const url = link?.getAttribute('href');
    if (!url) {
      return;
    }

    if (sourceId === OPENAI_WIDGET) {
      window?.parent?.postMessage({ name: 'resy-external', link: url }, '*');
    }

    window?.open(url);
  };

  useEffect(() => {
    const links = legalTextRef.current?.querySelectorAll('a[href]') || [];

    const setupLinks = Array.from(links).map((link) => {
      const onClick = (event) => {
        event.preventDefault();
        openLegalLink(link);
      };

      link.onclick = onClick;

      return () => {
        link.onclick = null;
        link.onkeydown = null;
      };
    });

    return () => {
      setupLinks.forEach((cleanup) => cleanup());
    };
  }, [sanitizedLegalText]);

  return (
    <div className="SummaryPage__legal" ref={legalTextRef}>
      {showOaiGlobalDiningAccessCopy && (
        <>
          <TranslationProvider translationKey="oai_gda_additional_access_copy">
            <span>
              Global Dining Access Members may have access to additional reservations or experiences, available through http://Resy.com or the Resy App.
            </span>
          </TranslationProvider>
          <br />
        </>
      )}
      <TranslationProvider translationKey="footer_text_secure">
        <span>All transmission of personally identifiable information is via secure channels.</span>
      </TranslationProvider>
      <span>&nbsp;</span>
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: sanitizedLegalText }} />
    </div>
  );
};

SummaryLegalText.propTypes = {
  legalText: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
};

SummaryLegalText.defaultProps = {
  sourceId: undefined,
};

export default SummaryLegalText;
